import { render, staticRenderFns } from "./AdminCategoryTypeEditModal.vue?vue&type=template&id=510d50e7"
import script from "./AdminCategoryTypeEditModal.vue?vue&type=script&lang=js"
export * from "./AdminCategoryTypeEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-api/api.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('510d50e7')) {
      api.createRecord('510d50e7', component.options)
    } else {
      api.reload('510d50e7', component.options)
    }
    module.hot.accept("./AdminCategoryTypeEditModal.vue?vue&type=template&id=510d50e7", function () {
      api.rerender('510d50e7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/AdminCategoryTypeEditModal.vue"
export default component.exports